// extracted by mini-css-extract-plugin
export default {"logo":"NavBar_logo__QHY62","avatar":"NavBar_avatar__6aUcw","btnNavbar":"NavBar_btnNavbar__AmO1H"};